import { Component } from '@angular/core';

@Component({
  selector: 'app-family-reset-password',
  templateUrl: './family-reset-password.component.html',
  standalone: false,
})
export class FamilyResetPasswordComponent {}
